import { useSelector } from 'react-redux';
import { isSiteAllowedByConfig } from '../utils/config.utils';

export const useWADiscountLabel = () => {
  const store = useSelector(({ quoting }) => quoting);
  const { data: rateData } = store;
  const sites = process.env.REACT_APP_WA_DISCOUNT_SITES;
  const isAllowedSite = isSiteAllowedByConfig(sites);
  const isWA = rateData?.stateAbrv === 'WA';

  return isAllowedSite && isWA;
};
